module.exports = "/images/st.svg?067ba5ac3538596b16a369a0fea92a61";